/* React */
import React, { useEffect } from "react";

/* React-Redux */
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { setToastMessage } from "src/redux/features/toast-message/toastMessageSlice";

/* Components */
import FirstFactor from "src/components/login/first-factor/FirstFactor";
import SecondFactor from "src/components/login/second-factor/SecondFactor";

/* Utils */
import LoginPageWrapper from "src/utils/wrapper/login-page-wrapper/LoginPageWrapper";

const Login: React.FC = () => {
  const dispatch = useDispatch();

  const authState = useSelector(
    (state: RootState) => state.auth
  );
  const { twoFa, error } = authState;

  useEffect(() => {
    if (error) {
      dispatch(
        setToastMessage({
          type: error.type,
          message: error.message,
          show: true,
        })
      );
    }
  }, [dispatch, error]);

  return (
    <LoginPageWrapper>
      {!twoFa?.twoFaRequired ? (
        <FirstFactor />
      ) : (
        <SecondFactor />
      )}
    </LoginPageWrapper>
  );
};

export default Login;
